module.exports = __webpack_public_path__ + "img/64.49d0f9a8.png";